import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST_SUCCESS:
      return { ...state, ...payload.entities.functionalOptionCodeMappings };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
